import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SelectCentroCosto } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const CentroCostoNivel1FormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue }) => {
  const optionsRef = React.useRef([])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      const matchedCentro = optionsRef.current.find(x => x._id === e.target.value)
      if (matchedCentro) {
        setFieldValue('centroCostoNivel1Info', `${matchedCentro.codigo} - ${matchedCentro.descripcion}`)
      } else {
        setFieldValue('centroCostoNivel1Info', '')
      }
    },
    [handleChange, setFieldValue]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('modal-select-centroCostoNivel2', e)
  }, [])

  const oneRowTrigger = React.useCallback(
    primeraFila => {
      setFieldValue('_idCentroCostoNivel1', primeraFila._id)
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='C. COSTO 1' htmlFor='modal-select-centroCostoNivel1' md={12} />
      <Col md={12}>
        <Field name='_idCentroCostoNivel1'>
          {({ field }) => (
            <SelectCentroCosto
              {...field}
              id='modal-select-centroCostoNivel1'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
              onKeyDown={onKeyDown}
              nivel={1}
              optionsRef={optionsRef}
              oneRowTrigger={oneRowTrigger}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel1FormGroup)
